<template>
  <STripTypeSelection
    :tripType="getTripType"
    @setTripType="setTripType"
  />
</template>
<script lang="ts">
export default {
  name: 'TripTypeSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { STripTypeSelection } from '@slg/web-customer-shared';
import { useStore } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const getTripType = computed(() => store.getters['booking/getTripType']);

function setTripType(newType: string) {
  store.commit('booking/setTripType', newType);
  emit('clearBookingRequestError');
}
</script>

<style scoped lang="scss">
</style>
